<template>


    <div v-if="showModal" id='modal-container' @keyup.esc="showModal = false" tabindex="0">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-dialog d-flex flex-column align-content-center" role="document">
                        <div class="modal-content"  style='z-index: 10'>
                            
                            <div class="modal-header">
                                <h5 class="modal-title">{{ title }}</h5>

                                <button type="button" id='close-button' class="close" data-dismiss="modal" aria-label="Close" @click="showModal = false" ref="closer">
                                    <span class='ti-close'></span>
                                </button>
                                <div id='buttons'>
                                    <button class="btn page-link" @click="active='dr'"> {{ $t("161") }}</button>
                                    <button class="btn page-link" @click="active='feedback'">{{ $t("162") }}</button>
                                    <button class="btn page-link" @click="active='prescription'">{{ $t("163") }}</button>
                                </div>
                            </div>

                            <!-- <p><a :href="link" target="frame">Open RDP</a></p> -->
                            
                            <div class="modal-body overflow-auto" style='width: 100%; height: 73vh;'>

                                <div style='background-color: #fff; padding: 20px;'>
                                    <div id='spinner-loading' class="d-flex justify-content-center align-content-middle">
                                        <div class="loader"></div> 
                                    </div>  

                                    <button class="btn page-link btn-form-rci" v-if="active == 'feedback' && rdp.status=='A' && form==false" @click="form=!form">
                                        {{ $t("164") }}
                                    </button>

                                    <div class="schedule-form">

                                        <transition name="fade">
                                            <div class="form-wrapper" v-if="form && active == 'feedback'">

                                                <div class="row">
                                                    <div class="form-group col-md-5">
                                                        <label class="control-label">
                                                            {{ $t("165") }} 
                                                        </label>
                                                        <input ref="psmschedule" class="form-control" v-model='rdp.psm_os' type="text" name="PSM" placeholder="0000" />
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="form-group col-md-5">
                                                        <label class="control-label">
                                                            {{ $t("166") }}  
                                                        </label>
                                                        <input class="form-control" v-model='rdp.sap_nw_number' type="text" name="note_number" placeholder="0000" />
                                                    </div>
                                                </div>   
                                                <div class="row">
                                                    <div class="form-group col-md-5">
                                                        <label class="control-label">
                                                            {{ $t("167") }}
                                                        </label>
                                                        <el-date-picker 
                                                            type="date" 
                                                            placeholder="" 
                                                            v-model='rdp.data_prog'
                                                            format='dd/MM/yyyy'
                                                            prefix-icon='ti-calendar'
                                                        >
                                                        </el-date-picker>
                                                    </div>
                                                </div>    
                                                <div class="row">
                                                    <div class="form-group col-md-5">
                                                        <label class="control-label">
                                                            {{ $t("168") }} 
                                                        </label>
                                                        <textarea class="form-control" v-model='rdp.motivo' type="text" name="reason" placeholder="" />
                                                    </div>
                                                </div>                                           

                                                <span v-if='error.status' style='color: red; font-size: 15px;'>{{ error.msg }}<br><br></span>
                                                <span v-if='msg.status' style='font-size: 15px;'>{{ msg.msg }}<br><br></span>

                                                <div class="row btns-prog">
                                                    <button class="btn page-link btn-prog-rci" @click="reset()">{{ $t("169") }} </button>
                                                    <button class="btn page-link btn-prog-rci" @click="save()">{{ $t("170") }} </button>
                                                </div>
                                                <!-- <hr class="line"> -->
                                            </div>
                                        </transition>
                                    </div>
                                    
                                    <iframe :src="link_rdp" name="frame" id='iframe_dr' frameborder='0' v-show='active=="dr"'></iframe>

                                    <!-- <iframe :src="link_rci" name="frame" id='iframe_feedback' frameborder='0' v-show='active=="feedback"'></iframe>-->

                                    <!-- Fazendo o html da RCI e desativando iframe -->

                                    <hr class="line"> 
    
                                    <div class="schedule-form">

                                        <transition name="fade">
                                            <div class="form-wrapper" v-if="active=='feedback'">

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="control-label">
                                                            {{ $t("171") }} 
                                                        </label>
                                                        {{rci_numero}}
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="control-label">
                                                            {{ $t("172") }}
                                                        </label>
                                                        {{rci_planta_area}}
                                                    </div>
                                                </div>
                                                <br>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="control-label">
                                                            {{ $t("165") }}
                                                        </label>
                                                        <input ref="psm" autofocus :disabled="disabled" class="form-control" maxlength="16" v-model='rci_psm_wo' type="text" name="PSM" placeholder="0000" />
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="control-label">
                                                            {{ $t("173") }} 
                                                        </label>
                                                        <el-date-picker 
                                                            type="date" 
                                                            placeholder="" 
                                                            v-model='rci_dt_intervencao'
                                                            format='dd/MM/yyyy'
                                                            prefix-icon='ti-calendar'
                                                            :disabled="disabled"
                                                            class="calendario"
                                                        >
                                                        </el-date-picker> 
                                                    </div>
                                                </div>   
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="control-label">
                                                            {{ $t("174") }}
                                                        </label>
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                            {{ $t("175") }} <input :disabled="disabled" class="form-control" maxlength="2" v-model='rci_tempo_gasto_inter_hour' type="text" name="Hours" placeholder="00" />
                                                                
                                                            </div>
                                                            <div class="col-md-6">
                                                            {{ $t("176") }} <input :disabled="disabled" class="form-control" maxlength="2" v-model='rci_tempo_gasto_inter_minu' type="text" name="Minutes" placeholder="00" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="control-label">
                                                            {{ $t("177") }}
                                                        </label>
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                            {{ $t("175") }} <input :disabled="disabled" class="form-control" maxlength="2" v-model='rci_tempo_parada_equip_hour' type="text" name="Hours" placeholder="00" />
                                                                
                                                            </div>
                                                            <div class="col-md-6">
                                                            {{ $t("176") }} <input :disabled="disabled" class="form-control" maxlength="2" v-model='rci_tempo_parada_equip_minu' type="text" name="Minutes" placeholder="00" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>    
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <label class="control-label">
                                                            {{ $t("178") }} 
                                                        </label>

                                                        <input :disabled="disabled" class="form-control" maxlength="40" v-model='rci_nome_resp_intervencao' type="text" name="Person responsible for intervention:" placeholder="ex: Jose" />               
                                                    </div>
                                                </div> 
                                                <hr class="line"> 
                                                <!-- PERGUNTAS -->

                                                <div class="row" v-if="questao=='normal'" style="margin: 10px 0px;">
                                                    <div class="col-md-12">
                                                        <label class="control-label">
                                                            {{number_a}} - {{ $t("179") }}
                                                        </label>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                            <input :disabled="disabled" type="radio" id="1" value="1" v-model="rci_resp_pergunta_a">
                                                            <label for="1">{{ $t("180") }} </label>
                                                            <br>
                                                            <input :disabled="disabled" type="radio" id="2" value="2" v-model="rci_resp_pergunta_a">
                                                            <label for="2">{{ $t("181") }}</label> 
                                                            <br>
                                                            <input :disabled="disabled" type="radio" id="3" value="3" v-model="rci_resp_pergunta_a">
                                                            <label for="3">{{ $t("182") }}</label>
                                                            <br>
                                                            <textarea :disabled="disabled" maxlength="200" class="col-md-12" v-model="rci_desc_resp_pergunta_a" ></textarea>
                                                           
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> 
                                                <br>
                                                <div class="row" v-if="questao=='oleo'" style="margin: 10px 0px;">
                                                    <div class="col-md-12">
                                                        <label class="control-label">
                                                            {{ $t("183") }}
                                                        </label>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                            <input :disabled="disabled" type="radio" id="1" value="1" v-model="rci_resp_pergunta_a">
                                                            <label for="1">{{ $t("180") }}</label>
                                                            <br>
                                                            <input :disabled="disabled" type="radio" id="2" value="2" v-model="rci_resp_pergunta_a">
                                                            <label for="2">{{ $t("184") }}</label> 
                                                            <br>
                                                            <input :disabled="disabled" type="radio" id="3" value="3" v-model="rci_resp_pergunta_a">
                                                            <label for="3">{{ $t("185") }}</label>
                                                            <br>
                                                            <textarea :disabled="disabled" maxlength="200" class="col-md-12" v-model="rci_desc_resp_pergunta_a" ></textarea>
                                                           
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="questao=='normal' && vibracao=='1' " style="margin: 10px 0px;">
                                                    <div class="col-md-12">
                                                        <label class="control-label">
                                                            {{number_b}} - {{ $t("186") }}
                                                        </label>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                            <input :disabled="disabled" type="radio" id="1" value="1" v-model="rci_resp_pergunta_b">
                                                            <label for="1">{{ $t("180") }}</label>
                                                            <br>                                                   
                                                            <input :disabled="disabled" type="radio" id="2" value="2" v-model="rci_resp_pergunta_b">
                                                            <label for="2">{{ $t("187") }}</label>
                                                            <br>
                                                            <textarea :disabled="disabled" maxlength="200" class="col-md-12" v-model="rci_desc_resp_pergunta_b" ></textarea>                                                        
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="questao=='oleo'" style="margin: 10px 0px;">
                                                    <div class="col-md-12">
                                                        <label class="control-label">
                                                            {{ $t("188") }}
                                                        </label>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                            <input :disabled="disabled" type="radio" id="1" value="1" v-model="rci_resp_pergunta_b">
                                                            <label for="1">{{ $t("180") }}</label>
                                                            <br>                                                   
                                                            <input :disabled="disabled" type="radio" id="2" value="2" v-model="rci_resp_pergunta_b">
                                                            <label for="2">{{ $t("189") }}</label>
                                                            <br>
                                                            <textarea :disabled="disabled" maxlength="200" class="col-md-12" v-model="rci_desc_resp_pergunta_b" ></textarea>
                                                       
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> 
                                                <div class="row" v-if="questao=='normal' && vibracao=='1'" style="margin: 10px 0px;">
                                                    <div class="col-md-12">
                                                        <label class="control-label">
                                                            {{number_c}} - {{ $t("190") }}
                                                        </label>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                            <input :disabled="disabled" type="radio" id="1" value="1" v-model="rci_resp_pergunta_c">
                                                            <label for="1">{{ $t("180") }}</label>
                                                            <br>                                                   
                                                            <input :disabled="disabled" type="radio" id="2" value="2" v-model="rci_resp_pergunta_c">
                                                            <label for="2">{{ $t("191") }}</label>
                                                            <br>
                                                            <textarea :disabled="disabled" maxlength="200" class="col-md-12" v-model="rci_desc_resp_pergunta_c" ></textarea>
                                                          
                                                            </div>
                                                        </div>
                                                    </div> 
                                                </div>
                                                <div class="row" v-if="questao=='oleo'" style="margin: 10px 0px;">
                                                    <div class="col-md-12">
                                                        <label class="control-label">
                                                            {{ $t("192") }}
                                                        </label>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                            <input :disabled="disabled" type="radio" id="1" value="1" v-model="rci_resp_pergunta_c">
                                                            <label for="1">{{ $t("193") }}</label>
                                                            <br>                                                   
                                                            <input :disabled="disabled" type="radio" id="2" value="2" v-model="rci_resp_pergunta_c">
                                                            <label for="2">{{ $t("194") }}</label>
                                                            <br>
                                                            <textarea :disabled="disabled" maxlength="40" class="col-md-12" v-model="rci_desc_resp_pergunta_c" ></textarea>
                                                            
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="questao=='normal'" style="margin: 10px 0px;">
                                                    <div class="col-md-12">
                                                        <label class="control-label">
                                                            {{number_d}} - {{ $t("195") }}
                                                        </label>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                            <input :disabled="disabled" type="radio" id="1" value="1" v-model="rci_resp_pergunta_d">
                                                            <label for="peg_04_resp_01">{{ $t("196") }}</label>
                                                            <br>                                                   
                                                            <input :disabled="disabled" type="radio" id="2" value="2" v-model="rci_resp_pergunta_d">
                                                            <label for="peg_04_resp_02">{{ $t("197") }}</label>
                                                            <br>
                                                            <textarea :disabled="disabled" maxlength="200" class="col-md-12" v-model="rci_desc_resp_pergunta_d" ></textarea>
                                                         
                                                            </div>
                                                        </div>
                                                     </div>
                                                </div>
                                                <!--NOVA QUESTÃO -->
<div class="row" style="margin: 10px 0px;">
    <div class="col-md-12">
    <label>{{number_e}} -  {{ $t("198") }}</label>
    <br>  
    <br>  
    <div class="row">
        <div class="col-md-2">
            <label>{{ $t("199") }} </label>         
        </div>
        <div class="col-md-10">
            <select style="width: 230px!important;" class="form-control" v-model="rci_currency" :disabled="disabled">
              <option v-for="item in rci_currency_value" v-bind:value="item.value">{{item.name}}</option>
            </select>

        </div>
    </div>
    <br>         

    <div class="row" v-if="this.decimal == 0">
        <div class="col-md-4">
            <label>{{ $t("200") }}</label>
            <money :disabled="disabled" class="form-control" maxlength="20"  v-model="rci_downtime" v-bind="money"></money>
        </div>
        <div class="col-md-4">
            <label>{{ $t("201") }}</label>
            <money :disabled="disabled" class="form-control" maxlength="20"  v-model="rci_secondary_damage" v-bind="money"></money>
        </div>
        <div class="col-md-4">
            <label>{{ $t("202") }}</label>
            <money :disabled="disabled" class="form-control" maxlength="20"  v-model="rci_preventive" v-bind="money"></money>            
        </div>
    </div>
    <div class="row" v-if="this.decimal == 1">
        <div class="col-md-4">
            <label>{{ $t("200") }}</label>
            <money :disabled="disabled" class="form-control" maxlength="20"  v-model="rci_downtime" v-bind="money_virgula"></money>
        </div>
        <div class="col-md-4">
            <label>{{ $t("201") }}</label>
            <money :disabled="disabled" class="form-control" maxlength="20"  v-model="rci_secondary_damage" v-bind="money_virgula"></money>
        </div>
        <div class="col-md-4">
            <label>{{ $t("202") }}</label>
            <money :disabled="disabled" class="form-control" maxlength="20"  v-model="rci_preventive" v-bind="money_virgula"></money>            
        </div>
    </div>

    
    
 
    </div>
</div>
                                                        <!--FIM NOVA QUESTÃO -->
                                                  
                                                <!--<div class="row" v-if="questao=='oleo'">
                                                    <div class="form-group col-md-12">
                                                        <label class="control-label">
                                                            The source of contamination was eliminated?
                                                        </label>
                                                        <div class="row">
                                                            <div class="form-group col-md-12">
                                                            <input type="radio" id="one" value="ol_peg_05_resp_01" v-model="link_rci">
                                                            <label for="ol_peg_05_resp_01">Yes</label>
                                                            <br>                                                   
                                                            <input type="radio" id="two" value="ol_peg_05_resp_02" v-model="link_rci">
                                                            <label for="ol_peg_05_resp_02">Not found</label>
                                                            <br>
                                                            <input type="radio" id="two" value="ol_peg_05_resp_03" v-model="link_rci">
                                                            <label for="ol_peg_05_resp_03">Not deleted</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>-->

                                                <!-- fim PERGUNTAS -->


                                                <span v-if='error.statusrci' style='color: red; font-size: 15px;'>{{ error.msgrci }}<br><br></span>
                                                <span v-if='msg.statusrci' style='font-size: 15px;'>{{ msg.msgrci }}<br><br></span>

                                                <div class="row btns-prog">                     
                                                    <button :disabled="disabled" class="btn page-link btn-prog-rci" @click="saveRci()"> {{ $t("203") }}</button>
                                                </div>
                                                <!-- <hr class="line"> -->
                                            </div>
                                        </transition>
                                    </div>
                                    <!-- FIM - Fazendo o html da RCI e desativando iframe -->

                                    <!-- Fazendo o html da PRESCRIÇÃO -->
                                    <div class="schedule-form" style="min-height:350px;background:#fff;">
                                        <transition name="fade">
                                            <div class="form-wrapper" v-if="active=='prescription'">
                                                <div v-if="active_pres == true">    
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <label class="control-label">
                                                                {{ $t("204") }} 
                                                            </label>
                                                            {{created_by}}
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="control-label">
                                                                {{ $t("205") }}
                                                            </label>
                                                            {{creation_date}}
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="control-label">
                                                                {{ $t("206") }}
                                                            </label>
                                                            {{edited_by}}
                                                        </div>
                                                         <div class="col-md-6">
                                                            <label class="control-label">
                                                                {{ $t("207") }}
                                                            </label>
                                                            {{last_updated}}
                                                        </div>
                                                    </div>
                                 
                                                    <div class="row" >
                                                        <div class="col-md-1">
                                                            <label class="control-label">
                                                                {{ $t("208") }}:
                                                            </label>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div v-if="status_prescription == 1" style=" color: #ae242b; font-weight: bold; ">
                                                                {{ $t("209") }}
                                                            </div>
                                                            <div v-if="status_prescription == 2" style="color: #24ae40; font-weight: bold; ">
                                                                {{ $t("210") }}
                                                            </div>
                                                            <div v-if="status_prescription == 3" style="color: #d4bd2a; font-weight: bold; ">
                                                                {{ $t("211") }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12" style="margin-top: 15px;">
                                                            <label class="control-label">
                                                                {{ $t("212") }}:
                                                            </label>
                                                            {{notes_save}}
                                                        </div>

                                                    </div>
                                                    <br>
                                                    <br>

                                                    <div v-for="(file, key) in list_file" class="file-listing">
                                                        <div v-if="file.file_name">
                                                        <iframe :src="link_prescription +file.id_prescription +'/'+ file.file_name" name="frame" id='iframe_dr' frameborder='0' ></iframe>
                                                        </div>

                                                    </div>

                                                </div>

                                                <br>

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <button class="col-md-12 btn page-link-presc-del btn-prog-rci" :disabled="disabled_del_presc" v-on:click="DeletePresc()">{{ $t("213") }}</button>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <button class="col-md-12 btn page-link-presc btn-prog-rci" :disabled="disabled_add_presc" v-on:click="addPresc()">{{ $t("214") }}</button>
                                                    </div>
                                                </div>

                                                <br>
                                                <div v-if="create_presc == true" style="background:#eee;padding:10px 10px;">

                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="control-label">
                                                                {{ $t("215") }}
                                                            </label>
                                                            {{report_number}}
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label class="control-label">
                                                                {{ $t("216") }}
                                                            </label>
                                                            {{ plant + ' / ' + area}}
                                                        </div>
                                                        <div class="col-md-4">
                                                            <label class="control-label">
                                                                {{ $t("217") }}
                                                            </label>
                                                            {{technique}}
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <label class="control-label">
                                                                {{ $t("218") }}:
                                                            </label>
                                                            <textarea maxlength="200" class="col-md-12" v-model="presc_note" ></textarea>
                                                        </div>
                                                    </div>
                                                     <br>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <label class="control-label">
                                                                {{ $t("219") }} 
                                                            </label>
                                                        </div>
                                              

                                                        <div class="col-md-12">
                                                          <button  class="col-md-3 btn page-link btn-prog-rci"  v-on:click="addFiles()">{{ $t("220") }}</button>
                                                        </div>

                                                        <div class="col-md-12" style="margin-top:30px;">
                                                            <input type="file" name="files" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div v-for="(file, key) in files" class="file-listing">
                                                            {{ file.name }} <span class="remove-file" v-on:click="removeFile( key )">{{ $t("221") }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div v-for="(file, key) in list_file" class="file-listing" v-if="file.file_name">
                                                                
                                                            {{ file.file_name }} <span class="remove-file" v-on:click="removeFileSave( file.file_name, file.id_prescription )">{{ $t("221") }}</span>
                                                                
                                                            </div>
                                                        </div>
                                                        <br>
                                                        <br>
                                                        
                                                        <br>
                                                        <div class="col-md-12" style="margin-top:30px;">
                                                          <button :disabled="disabled_submit" class="col-md-12 btn page-link-presc btn-prog-rci" v-on:click="submitFiles()">{{ $t("222") }}</button>
                                                        </div>
                                                    </div>
                                                </div>    
                                            </div>
                                        </transition>
                                    </div>  
                                    <!-- FIM - html da PRESCRIÇÃO --> 


                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </transition>
    </div>



    <!--
    <div>
        <iframe src="" name="frame"></iframe>
        <p><a :href="link" target="frame">Open RDP</a></p>

        <button @click='changeLink'>Trocar link</button>
    </div>
    -->

</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import axios from 'axios';
import { mapGetters } from 'vuex';
import mixin from '../../../../utils/mixin'

import money from 'v-money'
Vue.use(money, {precision: 4})

export default {
  name: 'charts',
  components: {
    [DatePicker.name]: DatePicker,
  },
  data () {
    return {
        price: '',
        decimal: '0',
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        }, 
        money_virgula: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        title: this.$t("299"),
        link_rdp: '',
        link_rci: '',
        id_rdp: '',
        active: 'dr',
        showModal: false,
        rdp: {},
        form: false,
        error:{
            msg: '',
            status: false,
            msgrci: '',
            statusrci: false
        },
        msg: {
            msg: '',
            status: false,
            msgrci: '',
            statusrci: false
        },
        rci_numero: '',
        rci_planta_area: '',
        rci_nome_resp_intervencao: '',
        rci_psm_wo: '',
        rci_tempo_gasto_inter_hour: '',                
        rci_tempo_gasto_inter_minu: '',               
        rci_tempo_parada_equip_hour: '',               
        rci_tempo_parada_equip_minu: '',
        rci_dt_intervencao: '',
        rci_resp_pergunta_a: '1',
        rci_desc_resp_pergunta_a: '',
        rci_resp_pergunta_b: '1',
        rci_desc_resp_pergunta_b: '',
        rci_resp_pergunta_c: '1',
        rci_desc_resp_pergunta_c: '',
        rci_resp_pergunta_d: '1',
        rci_desc_resp_pergunta_d: '',
        disabled: false,
        questao: 'normal',
        vibracao: '0',
        rci_currency: '',
        rci_currency_value: [],
        rci_downtime: '',
        rci_secondary_damage: '',
        rci_preventive: '',
        number_a: '1',
        number_b: '2',
        number_c: '3',
        number_d: '4',
        number_e: '5',
        //prescrição:
        link_prescription: '',
        create_presc: false,
        presc_note: '',
        files: [],
        disabled_submit: true,
        arquivo: '',
        list_file: [],
        created_by: '',
        creation_date: '',
        edited_by: '',
        last_updated: '',
        notes_save: '',
        active_pres: false,
        disabled_del_presc: true,
        disabled_add_presc: false,
        status_prescription: '',
    }
  },
  mixins: [mixin],
  methods: {
      addPresc(){
        this.create_presc = true
      },
      DeletePresc(){
        let self = this;
        
        if(this.status_prescription == '1'){
            const API = process.env.ROOT_API 
            //const APITESTE = 'http://192.168.0.156:5005/'

            let data = new FormData(); 
            data.append('id_prescription', this.id_prescription);

            axios({method: 'POST', url: API + 'v1/mysemeq-ambev/deletePrescription', data: data, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function (response) {
                alert(this.$t("341"))
                self.getPrescription()

            })
            .catch(function(error){
                // from mixin
                self.ApiErrorHandler(self, error.response.data.status_code);
            })
        }else{
            alert(this.$t("342"))
        }
      },
      getPrescriptionList(){
        let self = this;
        self.list_file = []
        
        const API = process.env.ROOT_API 
        //const APITESTE = 'http://192.168.0.156:5005/'

        let data = new FormData();
        data.append('component_id', self.component_id);
        data.append('ref_date', self.ref_date);
        data.append('report_id', self.id_rdp);


        axios({method: 'POST', url: API + 'v1/mysemeq-ambev/getPrescriptiong', data: data, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(function (response) {

            self.list_file = response.data
        })
        .catch(function(error){
            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
        })

      },
      getPrescription(){
        const API = process.env.ROOT_API 
        //const APITESTE = 'http://192.168.0.156:5005/'

        let self = this;
        self.files = []
        self.list_file = []
        self.active_pres = false
        self.disabled_del_presc = true
        self.disabled_add_presc = false
        this.create_presc = false
        self.presc_note = ''
        self.disabled_submit = true
        self.status_prescription = ''

        let data = new FormData();
        data.append('component_id', self.component_id);
        data.append('ref_date', self.ref_date);
        data.append('report_id', self.id_rdp);


        axios({method: 'POST', url: API + 'v1/mysemeq-ambev/getPrescriptiong', data: data, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(function (response) {

            console.log('RESULT: ', response.data)
            self.list_file = response.data
            self.presc_note = response.data[0].note

            self.id_prescription = response.data[0].id_prescription
            if(self.id_prescription){
                self.active_pres = true
            }
            self.created_by = response.data[0].create_by
            self.creation_date = response.data[0].create_at
            self.edited_by = response.data[0].updated_by
            self.last_updated = response.data[0].update_at
            self.notes_save = response.data[0].note
            
            self.link_prescription = 'http://mysemeq13.semeq.com.br/upload/'
            //self.link_prescription = 'http://mysemeq13.tst/upload/'

            //habilitar botão submit se tiver arquivo (self.disabled_submit = false)
            if(!response.data[0].file_name){
                self.disabled_submit = true
            }else {
                self.disabled_submit = false
            }

            self.status = response.data[0].status
            self.feedback_executed = response.data[0].feedback_executed


            if(self.status == 'A' && self.feedback_executed == 'N'){
                self.status_prescription = 1
                self.disabled_del_presc = false
                self.disabled_add_presc = false
            }
            if(self.status == 'F' && self.feedback_executed == 'S'){
                self.status_prescription = 2
                self.disabled_del_presc = true
                self.disabled_add_presc = true
            }
            if(self.status == 'F' && self.feedback_executed == 'N'){
                self.status_prescription = 3
                self.disabled_del_presc = true
                self.disabled_add_presc = true
            }


        })
        .catch(function(error){
            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
        })


      },  
      addFiles(){
        this.$refs.files.click();
      },
      submitFiles(){
 
        let self = this;


        //VERIFICA SE TEM ARQUIVO NA LISTA

        const API = process.env.ROOT_API 
        //const APITESTE = 'http://192.168.0.156:5005/'

        let data = new FormData(); 

        for( var i = 0; i < this.files.length; i++ ){
          let file = this.files[i];

          data.append('files[' + i + ']', file);
        }

        data.append('id_prescription', '');
        data.append('id_rdp', this.id_rdp);
        data.append('component_id', this.component_id);
        data.append('note', this.presc_note);
        data.append('user_id', this.user_id);
        data.append('ref_date', this.ref_date);

        //se tem um arquivo novo é normal
        if(this.files.length > 0){
            data.append('update_note', 'nao');
        }
        //nao tem um arquivo novo e já possui arquivos de prescrição salvas, então so atualiza a nota
        else{
            data.append('update_note', 'sim');
        }


        //http://api39.semeq.com.br/v1/mysemeq-ambev/createPrescription
        
        axios({
            method: 'POST', url: API + 'v1/mysemeq-ambev/createPrescription', data: data, 
            headers: { 
                Authorization: `Bearer ${localStorage.getItem('user-token')}`, 
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(function({ data }){
            if (data.status == true){
                alert(this.$t("343"))
                self.files = ''
                self.getPrescription()
            }
            if (data.status == false){
                alert(this.$t("344"))
            }
        })
        .catch(function(error){
            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
        })


        

      },

      /*
        Handles the uploading of files
      */
      handleFilesUpload(){
        let uploadedFiles = this.$refs.files.files;

        /*
          Adds the uploaded file to the files array
        */
        for( var i = 0; i < uploadedFiles.length; i++ ){

            let filename = uploadedFiles[i].name

            let nameFile = filename.split('.').slice(0, -1).join('.')

            let regex = /\W|_/;

            let comCaracterEspecial = regex.test(nameFile)


            if(uploadedFiles[i].type == 'application/pdf' && comCaracterEspecial == false){
                this.files.push( uploadedFiles[i] );
            }
            else{
                alert(this.$t("345"))
            }
        }
      },

      /*
        Removes a select file the user has uploaded
      */
      removeFile( key ){
        this.files.splice( key, 1 );
      },
      removeFileSave( filename,  id_prescription){

        if(this.status_prescription == '1'){
            const API = process.env.ROOT_API 
            //const APITESTE = 'http://192.168.0.156:5005/'

            let data = new FormData(); 
            data.append('filename', filename);
            data.append('id_prescription', id_prescription);

            let self = this;
            axios({method: 'POST', url: API + 'v1/mysemeq-ambev/deletePrescriptiongFile', data: data, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function (response) {
                alert(this.$t("346"))
                console.log('RESULT: ', response.data)
                self.getPrescriptionList()

            })
            .catch(function(error){
                // from mixin
                self.ApiErrorHandler(self, error.response.data.status_code);
            })
        }else{

            alert(this.$t("347"))
        }
        
      },
      toggleLink(link){
        this.link = link;
      },
      save(){
        
        this.msg.status = false;

        let error = false;

        if (!this.rdp.psm_os && !this.rdp.sap_nw_number){
            this.error.status = true;
            this.error.msg = 'Please fill in PSM / W.O. or Note Number!';
            error = true;
        }

        if (!this.rdp.motivo) {
            this.msg.status = false;
            this.error.status = true;
            this.error.msg = 'Fill in the reason of schedule!';
            error = true;
        }
        
        let t = new Date().setHours(0, 0, 0, 0);
        let d = this.rdp.data_prog;
        let end_date = new Date(new Date().setYear(new Date().getFullYear() + 1));

        if (d - t < 0) {
            this.error.status = true;
            error = true;
            this.error.msg = 'Please select a date greater or equal than today!';
        } else if (d - end_date > 0) {
            this.error.status = true;
            error = true;
            this.error.msg = 'The date of the schedule should be less than 1 year!';
        }

        if(error){ return false; }

        this.error.status = false;

        let data = this.rdp.data_prog
        let dia  = data.getDate().toString();
        let diaF = (dia.length == 1) ? '0'+dia : dia;
        let mes  = (data.getMonth()+1).toString(); //+1 pois no getMonth Janeiro começa com zero.
        let mesF = (mes.length == 1) ? '0'+mes : mes;
        let anoF = data.getFullYear();

        data = diaF + '/' + mesF + '/' + anoF;

        let model = {
            'prog_n': this.rdp.psm_os,
            'prog_dt': data,
            'prog_motivo': this.rdp.motivo,
            'prog_nota': this.rdp.sap_nw_number,
            'id': this.id_rdp
        }

        const API = process.env.ROOT_API
        
        let self = this;
        axios({method: 'POST', url: API + 'v1/save-rci-prog', data: model, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function({ data }){
                if (data){
                    self.msg.status=data;
                    self.msg.msg = 'Successfully scheduled!';
                }
                
            })
            .catch(function(error){
                // from mixin
                self.ApiErrorHandler(self, error.response.data.status_code);
            })
      },
      reset(){
        this.form = false;
        this.error.status = false;
        this.msg.status = false;
      },
      get_rci_prog(){
        const API = process.env.ROOT_API

        let self = this;
        axios({method: 'GET', url: API + 'v1/get-rci-prog', params: {rdp: this.id_rdp}, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function({ data }){
                self.rdp=data;
                if (self.rdp.data_prog){
                    let parts = self.rdp.data_prog.split("/");
                    self.rdp.data_prog = new Date(parts[2], parts[1] - 1, parts[0]);
                }
            })
            .catch(function(error){
                // from mixin
                self.ApiErrorHandler(self, error.response.data.status_code);
            })
    },
    isNumber: function(n){
        return !isNaN(parseFloat(n)) && isFinite(n);
    },
    get_currenty: function(){
        let self = this;

        const API = process.env.ROOT_API
        
        axios({method: 'GET', url: API + 'v1/mysemeq-ambev/catMoeda', params: '', headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function({ data }){
                let res = data;

                let lista = []
                for (var key in res) {         
                    lista.push({ 
                        'value': res[key].id
                        , 'name': res[key].id == 3 ? 'Euro -  €' : res[key].simbolo
                        , 'decimal': res[key].tipo_decimal
                    })
                }


                self.rci_currency_value = lista
                //para pegar id selecionado
                //JSON.stringify(this.rci_currency.value)                
               
            })
            .catch(function(error){
                // from mixin
                self.ApiErrorHandler(self, error.response.data.status_code);
            })
    },
    get_rci: function(){
        let self = this;

        const API = process.env.ROOT_API
        let idrdp = self.link_rci

        axios({method: 'GET', url: API + 'v1/mysemeq-ambev/RciSemeq', params: {idrdp: idrdp}, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function({ data }){
                self.rci = data;

                //se a rci ja vier preechida desabilita todos os campos e não pode editar.           
                if(!self.rci[0].psm_os){
                    self.disabled = false
                }else{
                    self.disabled = true
                }

                self.questao = 'normal'
                self.vibracao = '0'

                self.number_a = '1'
                self.number_b = '0'
                self.number_c = '0'
                self.number_d = '2'
                self.number_e = '3'

                if(self.technique_id == 3){
                    self.questao = 'oleo'
                    self.number_e = '4'
                }

                if(self.technique_id == 2){
                    self.questao = 'normal'
                    self.vibracao = '1'

                    self.number_a = '1'
                    self.number_b = '2'
                    self.number_c = '3'
                    self.number_d = '4'
                    self.number_e = '5'
                }

                self.rci_numero = self.report_number
                self.rci_planta_area = self.plant + ' / ' + self.area
                self.rci_nome_resp_intervencao = self.rci[0].nome_resp_intervencao == undefined ? self.name_user : self.rci[0].nome_resp_intervencao
                self.rci_psm_wo = self.rci[0].psm_os                 
                self.rci_tempo_gasto_inter_hour = self.rci[0].tempo_gasto_inter_hour                 
                self.rci_tempo_gasto_inter_minu = self.rci[0].tempo_gasto_inter_minu                 
                self.rci_tempo_parada_equip_hour = self.rci[0].tempo_parada_equip_hour                
                self.rci_tempo_parada_equip_minu = self.rci[0].tempo_parada_equip_minu                 

                if (self.rci[0].dt_intervencao){
                    let parts = self.rci[0].dt_intervencao.split("GMT");
                    self.rci_dt_intervencao = new Date(parts[0]);  
                }
               
                self.rci_resp_pergunta_a = self.rci[0].resp_pergunta_a 
                self.rci_desc_resp_pergunta_a = self.rci[0].desc_resp_pergunta_a 

                self.rci_resp_pergunta_b = self.rci[0].resp_pergunta_b 
                self.rci_desc_resp_pergunta_b = self.rci[0].desc_resp_pergunta_b

                self.rci_resp_pergunta_c = self.rci[0].resp_pergunta_c 
                self.rci_desc_resp_pergunta_c = self.rci[0].desc_resp_pergunta_c

                self.rci_resp_pergunta_d = self.rci[0].resp_pergunta_d 
                self.rci_desc_resp_pergunta_d = self.rci[0].desc_resp_pergunta_d

                self.rci_downtime = self.rci[0].downtime == null ? '0.00' : self.rci[0].downtime
                self.rci_secondary_damage = self.rci[0].sec_damage == null ? '0.00' : self.rci[0].sec_damage
                self.rci_preventive = self.rci[0].work_avoided == null ? '0.00' : self.rci[0].work_avoided
                self.rci_currency = self.rci[0].moeda



                //console.log('RCI: ', self.rci)
               
            })
            .catch(function(error){
                // from mixin
                self.ApiErrorHandler(self, error.response.data.status_code);
            })

    },
    saveRci(){
                
        this.msg.statusrci = false;
        this.error.msgrci = '';        

        let error = false;

        if (!this.rci_psm_wo){
            this.error.statusrci = true;
            this.error.msgrci = 'Please fill in PSM / W.O!';
            error = true;
            return false
            
        }

        if (!this.rci_dt_intervencao){
            this.error.statusrci = true;
            this.error.msgrci = 'Please fill Intervention Date!';
            error = true;
            return false
            
        }

        if (!this.rci_nome_resp_intervencao){
            this.error.statusrci = true;
            this.error.msgrci = 'Please fill Person responsible for intervention!';
            error = true;
            return false
            
        }
   
        if (this.isNumber(this.rci_tempo_gasto_inter_hour) == false) {
            this.msg.statusrci = false;
            this.error.statusrci = true;
            this.error.msgrci = ' Please fill only number in Hours and Minutes';
            error = true;
            return false
        }

        if (this.isNumber(this.rci_tempo_gasto_inter_minu) == false) {
            this.msg.statusrci = false;
            this.error.statusrci = true;
            this.error.msgrci = 'Please fill only number in Hours and Minutes';
            error = true;
            return false
        }

        if (this.isNumber(this.rci_tempo_parada_equip_hour) == false) {
            this.msg.statusrci = false;
            this.error.statusrci = true;
            this.error.msgrci = 'Please fill only number in Hours and Minutes';
            error = true;
            return false
        }

        if (this.isNumber(this.rci_tempo_parada_equip_minu) == false) {
            this.msg.statusrci = false;
            this.error.statusrci = true;
            this.error.msgrci = 'Please fill only number in Hours and Minutes';
            error = true;
            return false
        }

        if (!this.rci_currency){
            this.error.statusrci = true;
            this.error.msgrci = 'Please select a currency!';
            error = true;
            return false
            
        }

        if (!this.rci_downtime){
            this.error.statusrci = true;
            this.error.msgrci = 'Please fill Downtime!';
            error = true;
            return false
            
        }

        if (!this.rci_secondary_damage){
            this.error.statusrci = true;
            this.error.msgrci = 'Please fill Secondary damage!';
            error = true;
            return false
            
        }

        if (!this.rci_preventive){
            this.error.statusrci = true;
            this.error.msgrci = 'Please fill Preventive work avoided!';
            error = true;
            return false
            
        }

        //console.log('tecnica: ', this.technique_id )
        //console.log('A: ', this.rci_resp_pergunta_a )
        //console.log('B: ', this.rci_resp_pergunta_b )
        //console.log('C: ', this.rci_resp_pergunta_c )
        //console.log('D: ', this.rci_resp_pergunta_d )

        if(this.technique_id != 3 && this.technique_id != 2){  
        //console.log('TECNICA DIFERENTE' )  
            if (!this.rci_resp_pergunta_a ||  !this.rci_resp_pergunta_d) {
                this.msg.statusrci = false;
                this.error.statusrci = true;
                this.error.msgrci = 'Please answer all questions!';
                error = true;
                return false
            }else{
                this.saveRciOk();
            }
        }


        //se for tecnica de vibração questões 1, 2, 3 e 4 são obrigatorias
        if(this.technique_id == 2){
            // console.log('VIBRACAO' )
            if (!this.rci_resp_pergunta_a || !this.rci_resp_pergunta_b || !this.rci_resp_pergunta_c || !this.rci_resp_pergunta_d ) {
                this.msg.statusrci = false;
                this.error.statusrci = true;
                this.error.msgrci = 'Please answer all questions!';
                error = true;
                return false
            }else{
                this.saveRciOk();
            }
        }
        //se for tecnica de oleo questões 1, 2, 3 são obrigatorias    
        if(this.technique_id == 3){
            //console.log('OLEO' )
            if (!this.rci_resp_pergunta_a || !this.rci_resp_pergunta_b || !this.rci_resp_pergunta_c) {
                this.msg.statusrci = false;
                this.error.statusrci = true;
                this.error.msgrci = 'Please answer all questions!';
                error = true;
                return false
            }else{
                this.saveRciOk();
            }
        }

        
    },
    saveRciOk(){

        this.msg.msgrci = '';

        //console.log('RDP id: ', this.link_rci)

        let model = {
            'idrdp': this.link_rci,
            'psm_os': this.rci_psm_wo,
            'user_id': '',
            'dt_inter': this.rci_dt_intervencao,
            'tmp_gasto': this.rci_tempo_gasto_inter_hour + 'H' + this.rci_tempo_gasto_inter_minu,
            'tmp_parada': this.rci_tempo_parada_equip_hour + 'H' + this.rci_tempo_parada_equip_minu,
            'nm_resp_inter': this.rci_nome_resp_intervencao,
            'resp_a': this.rci_resp_pergunta_a == undefined ? '' : this.rci_resp_pergunta_a,
            'desc_a': this.rci_desc_resp_pergunta_a == undefined ? '' : this.rci_desc_resp_pergunta_a,
            'resp_b': this.rci_resp_pergunta_b == undefined ? '' : this.rci_resp_pergunta_b,
            'desc_b': this.rci_desc_resp_pergunta_b == undefined ? '' : this.rci_desc_resp_pergunta_b,
            'resp_c': this.rci_resp_pergunta_c == undefined ? '' : this.rci_resp_pergunta_c,
            'desc_c': this.rci_desc_resp_pergunta_c == undefined ? '' : this.rci_desc_resp_pergunta_c,
            'resp_d': this.rci_resp_pergunta_d == undefined ? '' : this.rci_resp_pergunta_d,
            'desc_d': this.rci_desc_resp_pergunta_d == undefined ? '' : this.rci_desc_resp_pergunta_d,
            'resp_e': '',
            'desc_e': '',
            'resp_f': '',
            'desc_f': '',
            'resp_final': '',
            'motivo': '',
            'id_moeda': this.rci_currency,
            'downtime': this.rci_downtime,
            'sec_damage': this.rci_secondary_damage,
            'work_avoided': this.rci_preventive
        }


        //console.log('model: ', model)       
        const API = process.env.ROOT_API            
      
        let self = this;
        axios({method: 'POST', url: API + 'v1/mysemeq-ambev/bxRciSemeq', data: model, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(function({ data }){
            if (data){
                self.msg.statusrci=data;
                self.msg.msgrci = 'Successfully scheduled!';
            }
            
        })
        .catch(function(error){
            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
        })
        
    },
    ...mapGetters(['modal_rdp'])
  },
  computed: {
    rdpModal: function () {
        return this.modal_rdp();
    },
  },
  watch: {
    files: function(){
        if(this.files.length > 0){
            this.disabled_submit = false
        }else {
            this.disabled_submit = true
        }

    },
    rci_currency: function(){
        //console.log('rci_currency_value: ', JSON.stringify(this.rci_currency_value))
        //console.log('rci_currency: ', JSON.stringify(this.rci_currency))

        let res = this.rci_currency_value

        for (var key in res) {      
            if(res[key].value == this.rci_currency) {
                this.decimal = res[key].decimal
            } 
          
        }
     
        //console.log('decimal: ', this.decimal)       

    },
    form: function(){
        if(this.form == true){
            this.$nextTick(function () {                
                this.$refs.psmschedule.focus()
            })
        }
    },
    active: function(){
        if(this.active == 'feedback'){
            this.$nextTick(function () {                
                this.$refs.psm.focus()
            })
        } 
        if(this.active == 'prescription'){
            this.getPrescription()
        }       
    },
    show: function(newValue){
        this.showModal = newValue;
    },
    rdpModal: function (newValue){
        this.link_rdp = newValue.link_rdp;
        this.link_rci = newValue.link_rci;
        this.technique_id = newValue.technique_id;
        this.technique = newValue.technique;
        this.component_id = newValue.component_id;
        this.id_rdp = newValue.id_rdp;
        this.ref_date = newValue.ref_date;
        //para verificar prescrição:
        console.log('component_id: ', newValue.component_id)
        console.log('id_rdp: ', newValue.id_rdp)
        console.log('ref_date: ', newValue.ref_date)

        this.report_number = newValue.report_number;
        this.plant = newValue.plant;
        this.area = newValue.area;
        let res = JSON.parse(localStorage.getItem('users'));
        this.name_user = res.users.name
        this.user_id = res.users.id
        //console.log('link_rci: ', this.link_rci);
        //console.log('technique_id: ', this.technique_id);
        //console.log('id_rdp: ', this.id_rdp);
        //console.log('report_number: ', this.report_number);

        this.showModal = true;
        this.active = 'dr';
        this.get_rci();
        this.get_rci_prog();
        this.reset();
        this.get_currenty();

        this.$nextTick(function () {
            this.$refs.closer.focus()
        })
    }
  },
  mounted(){
      this.link = this.link_rdp;
      
  }
}
</script>

<style scoped>

input{
  background-color: #ccc!important;
  color: #000 !important;
}

.modal-mask {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-header{
    height: 90px;
    align-items: center;
    align-content: center;
    color: white;
    margin-bottom: 10px;
}

.modal-body{
    margin: 0;
    padding: 0;
    overflow: auto;
    /* max-height: 80vh;*/
}

.modal-dialog{
    width: 70vw;
    padding: 0;
}

.modal-content{
    padding: 0 20px;
    /* background: #1f1f20; */
    background: #2a2a2e;
    height: 90vh;
}

#close-button{
    outline: none;
    z-index: 10;
    margin-top: -15px;
    margin-right: -20px;
}

.ti-close{
    color: white;
    border-color: white;
    text-shadow: white;
}

.modal-title{
    color: white;
    font-weight: 100;
    font-size: 22px;
    margin: -10px 1px;
}

#iframe_dr, #iframe_feedback{
    width: 100%;
    height: 100vh;
    position: relative;
    z-index: 2;
    margin: 0;
    
}

#buttons{
    /* height: 40px; */
    /* margin-top: -45px; */
    position: absolute;
    left: 35px;
    top: 45px;
}

.page-link{
    background: #343a40;
    border-color: #343a40;
    color: white;
    transition: background 0.4s;
    cursor: pointer;
    height: 35px;
}

.page-link:hover{
    background: #454d55;
}

#spinner-loading{
    position: absolute;
    top: 45%;
    transform: translateY(-50%);
    left: 50%;
    transform: translateX(-50%);
}

.loader {
    border: 6px solid #f3f3f3; /* Light grey */
    border-top: 6px solid #72b5e1; /* Blue */
    border-radius: 50%;
    width: 35px;
    height: 35px;
    animation: spin 2s linear infinite;
    margin: 0 auto;
    z-index: 1;
}

.schedule-form {
    background-color: #fff;
    position: relative;
    z-index: 2;
    /* margin-top: -40px; */
}

.form-wrapper{
    margin: 20px auto;
    margin-bottom: 40px;
}

.btn-form-rci{
    margin-bottom: 20px;
}

.form-control{
    background-color: #ccc !important;
    color: #000!important;
}

.form-control::placeholder{
 color: #8c8c8c !important;
}

.line{
    display: flex;
    align-self: center;
    background-color: rgb(189, 189, 189);
    height: 1px;
    margin: 20px auto;
    width: 98%;
}

.btns-prog{
    padding: 30px 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 770px) {
    .modal-dialog {
        width: 90vw;
        padding: 0;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
    }
}

input[type="file"]{
    display: none;
}

div.file-listing{
    border: 1px solid #ccc;
    padding:5px 10px;
    width: 100%;
 }

span.remove-file{
    color: red;
    cursor: pointer;
    float: right;
}

.page-link-presc{
    background: #1c3b59!important;
    border-color: #1c3b59!important;
    color: white;
    transition: background 0.4s;
    cursor: pointer;
    height: 35px;
}

.page-link-presc:hover{
    background: #1c3b59!important;
    border-color: #1c3b59!important;
    color: white;
    transition: background 0.4s;
    cursor: pointer;
    height: 35px;
}
.page-link-presc-del{
    background: #ae242b!important;
    border-color: #ae242b!important;
    color: white;
    transition: background 0.4s;
    cursor: pointer;
    height: 35px;
}

.page-link-presc-del:hover{
    background: #ae242b!important;
    border-color: #ae242b!important;
    color: white;
    transition: background 0.4s;
    cursor: pointer;
    height: 35px;
}


</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/rdp_modal.vue